module.exports = __webpack_public_path__ + "img/load-more-active.e9183d5a.svg";